/**
 * Jackbox-style player colors - vibrant and distinct
 * Each player gets assigned a color index (0-7) when joining
 */

export interface PlayerColor {
  name: string;
  bg: string;        // Background color (CSS class)
  text: string;      // Text color (CSS class)
  border: string;    // Border color (CSS class)
  hex: string;       // Hex value for dynamic use
  ring: string;      // Ring/glow color (CSS class)
}

// Jackbox-inspired vibrant color palette
export const PLAYER_COLORS: PlayerColor[] = [
  {
    name: 'blue',
    bg: 'bg-blue-500',
    text: 'text-blue-500',
    border: 'border-blue-500',
    hex: '#3b82f6',
    ring: 'ring-blue-500/50',
  },
  {
    name: 'orange',
    bg: 'bg-orange-500',
    text: 'text-orange-500',
    border: 'border-orange-500',
    hex: '#f97316',
    ring: 'ring-orange-500/50',
  },
  {
    name: 'green',
    bg: 'bg-emerald-500',
    text: 'text-emerald-500',
    border: 'border-emerald-500',
    hex: '#10b981',
    ring: 'ring-emerald-500/50',
  },
  {
    name: 'purple',
    bg: 'bg-purple-500',
    text: 'text-purple-500',
    border: 'border-purple-500',
    hex: '#a855f7',
    ring: 'ring-purple-500/50',
  },
  {
    name: 'pink',
    bg: 'bg-pink-500',
    text: 'text-pink-500',
    border: 'border-pink-500',
    hex: '#ec4899',
    ring: 'ring-pink-500/50',
  },
  {
    name: 'cyan',
    bg: 'bg-cyan-500',
    text: 'text-cyan-500',
    border: 'border-cyan-500',
    hex: '#06b6d4',
    ring: 'ring-cyan-500/50',
  },
  {
    name: 'yellow',
    bg: 'bg-yellow-500',
    text: 'text-yellow-500',
    border: 'border-yellow-500',
    hex: '#eab308',
    ring: 'ring-yellow-500/50',
  },
  {
    name: 'red',
    bg: 'bg-red-500',
    text: 'text-red-500',
    border: 'border-red-500',
    hex: '#ef4444',
    ring: 'ring-red-500/50',
  },
];

/**
 * Get the color object for a player's color index
 */
export function getPlayerColor(colorIndex: number): PlayerColor {
  return PLAYER_COLORS[colorIndex % PLAYER_COLORS.length];
}

/**
 * Get initials from a player name (up to 2 characters)
 */
export function getPlayerInitials(name: string): string {
  const words = name.trim().split(/\s+/);
  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
}
